import React from 'react';
import Loading from 'widget/Loading/Loading';
import Bundle from './Bundle';

// 懒加载
export const createBundle = (component) => (props) => (
  <Bundle load={component}>
    {(Component) => (Component ? <Component {...props} /> : <Loading />)}
  </Bundle>
);



// WEBPACK FOOTER //
// ./src/widget/Common/index.js